import React, {useState, Children, useEffect} from 'react'
import {Form, Formik} from 'formik'
import {AppBar, Button, CircularProgress, Grid, Grow, MobileStepper} from '@material-ui/core'

const FormStepper = ({children, showControls, showSteps, onSubmit, datakey, ...props}) => {
  const {localStorage} = window
  const childrenArray = Children.toArray(children)
  const [step, setStep] = useState(0)
  let currentChildren = React.cloneElement(childrenArray[step], {datakey})
  const isLastStep = step === childrenArray.length - 1


  useEffect(() => {
    let data = JSON.parse(localStorage.getItem(datakey))
    const leftStep = data && parseInt(data.leftStep)
    if (isLastStep) {
      localStorage.clear()
    }
    if (leftStep) {
      setStep(leftStep)
    }
  }, [localStorage, isLastStep, datakey])

  const submit = async (values, helpers) => {
    if (currentChildren.props.onSubmit) {
      const nextStep = await currentChildren.props.onSubmit(values, helpers, step)
      const value = {...values, leftStep: (nextStep).toString()}
      if (currentChildren.props.saveFields) {
        localStorage.setItem(datakey, JSON.stringify(value))
      }
      setStep(nextStep)
      return
    }
    if (isLastStep) {
      localStorage.clear()
    } else {
      const value = {...values, leftStep: (step + 1).toString()}
      // console.info('Setting values to localStorage...')
      // console.log(value)
      localStorage.setItem(datakey, JSON.stringify(value))
      setStep(s => s + 1)
    }
  }

  return (
    <Formik
      {...props}
      validationSchema={currentChildren.props.validationSchema}
      onSubmit={submit}
    >
      {({isSubmitting, errors}) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {currentChildren}
            </Grid>
          </Grid>
          {(showControls || showSteps) && (
            <AppBar color="transparent" elevation={0} position="static" style={{top: 'initial', bottom: 0, alignItems: 'center'}}>
              {currentChildren.props.showControls && (
                <Grid justify="space-between" container spacing={2} style={{ margin: '20px 0' }}>
                  {(step > 0 && step < 10) && (
                    <Grid item xs={12}>
                      <Button
                        disabled={isSubmitting}
                        onClick={() => setStep((s) => s - 1)}
                        fullWidth
                      >
                        Voltar
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Grow mountOnEnter in timeout={1300}>
                      <Button
                        startIcon={isSubmitting ? <CircularProgress size="1rem" /> : null}
                        disabled={isSubmitting ?? errors}
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                      >
                        {isSubmitting ? 'Enviando...' : (isLastStep || currentChildren.props.onSubmit) ? currentChildren.props.submitText : 'Continuar'}
                      </Button>
                    </Grow>
                  </Grid>
                </Grid>
              )}
              {showSteps && (
                <MobileStepper
                  variant="progress"
                  steps={childrenArray.length}
                  position="bottom"
                  backButton={false}
                  nextButton={false}
                  activeStep={step}
                />
              )}
            </AppBar>
          )}
        </Form>
      )}
    </Formik>
  )
}

FormStepper.propTypes = {

}

export default FormStepper
